<template>
  <div class="bg-white">
    <div class="">
      <div role="list" class="grid grid-cols-1 gap-4 sm:gap-4 lg:grid-cols-3">
        <div v-for="contractOption in contractOptions" @click="emit('onContractSelected', contractOption.id);" :key="contractOption.name" class="transition duration-250 group col-span-1 flex shadow-sm rounded-xl cursor-pointer border border-solid  hover:rounded-xl hover:bg-gradient-to-tr hover:to-brand-primary-light hover:from-brand-primary-dark" :class="[ selected === contractOption.id ? 'border-none bg-gradient-to-tr to-brand-primary-light from-brand-primary-dark' : '' ]">
          <div
            class="flex-1 flex items-start justify-between  hover:bg-transparent rounded-xl truncate relative" :class="[selected === contractOption.id ? 'bg-transparent' : 'bg-white']"
            >
            <div class="flex-1 px-8 py-2 text-lg truncate">
              <p class="text-2xl leading-none transition duration-250 text-black font-poppins-bold" :class="[selected === contractOption.id ? 'text-white' : 'text-black']">{{ utilityService.toTitleCase(contractOption.name) }}<br> Contract</p>
              <p class="font-poppins" :class="['text-sm transition duration-250', contractOption.displayDiscount ? 'text-decoration-line: line-through text-gray-300' : 'text-gray-900']">{{ activationFee(contractOption, false) }}</p>
              <p class="text-sm transition duration-250 text-gray-900 font-poppins" v-if="contractOption.displayDiscount">{{ activationFee(contractOption, true) }}</p>
            </div>
            <div class="flex-shrink-0 pl-4 pr-4 flex items-start justify-start ">
              <button v-if="selected !== contractOption.id" type="button" class="text-right mt-6 mr-2 w-7 h-7 text-white rounded-full border border-solid"
                :class="[ selected === contractOption.id ? 'text-black' : 'text-gray-600 group-hover:text-gray-400' ]"
                >
              </button>
              <CheckCircleSolidIcon v-if="selected === contractOption.id" class="text-right pt-6 pr-2 w-8 h-8 text-white" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { injectStrict } from '../../plugins/vueServiceContainerPlugin';
import { UtilityServiceInterface } from '@/services/utilityServiceInterface';
import { CheckCircleIcon } from '@heroicons/vue/outline';
import { CheckCircleIcon as CheckCircleSolidIcon } from '@heroicons/vue/solid';
import { defineProps, defineEmits } from 'vue';

const utilityService = injectStrict<UtilityServiceInterface>('UtilityServiceInterface');

type ContractOption = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
}

defineProps<{
  contractOptions: Array<ContractOption>,
  selected: string
}>();

const emit = defineEmits<{(e: 'onContractSelected', id: string): void}>();

const activationFee = (contractOption: ContractOption, discounted: boolean): string => {
  if (discounted) {
    if (contractOption.discountedPrice === 0) {
      return 'Free Activation';
    } else {
      return `$${contractOption.discountedPrice} Activation Fee`;
    }
  }
  return `$${contractOption.price} Activation Fee`;
};
</script>
